
import React, { PropTypes } from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import testimonialRepository from '../../services/testimonials';
import formInitialiser       from '../../services/formInitialiser';
import FormSubmitter         from '../../services/formSubmitter';

import * as courseListActions from '../../actions/courseList';

import Button        from '../Button';
import Input         from '../Input';
import InlineError   from '../InlineError';
import InputGroup    from '../InputGroup';
import InputSection  from '../InputSection';
import Label         from '../Label';
import TextArea      from '../TextArea';

class TestimonialForm extends React.Component {

    render() {

        const {
            fields: { author_name, organisation_name, content },
            handleSubmit, submitting, selectedCourseId
        } = this.props;

        const createSuccessFunc = courseId => {
            this.props.createSuccess(courseId);
            this.props.loadCourses();
        }

        const createSuccess = createSuccessFunc.bind(this, selectedCourseId);
        const updateSuccess = this.props.updateSuccess.bind(this, selectedCourseId);

        var formSubmitter = new FormSubmitter({
            create: testimonialRepository.create,
            update: testimonialRepository.update,
            createSuccess,
            updateSuccess
        });

        return (
            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.mode)) }>

                <InputSection>

                    <InputGroup>
                        <Label isRequired="true">Author Name</Label>
                        <Input { ...author_name } errors={ author_name.error } />
                        <InlineError errors={ author_name.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Organisation</Label>
                        <Input { ...organisation_name } errors={ organisation_name.error } />
                        <InlineError errors={ organisation_name.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Testimonial</Label>

                        <TextArea { ...content }
                                  errors={ content.error }
                                  showToolbar="true"
                                  className={ style['testimonial-editor'] } />

                        <InlineError errors={ content.error } />
                    </InputGroup>

                </InputSection>

                <div styleName="testimonial-button-panel">

                    <Button className={ style['testimonial-button'] }
                            onClick={ this.props.cancelTestimonialFormOverlay }
                            type="button"
                            theme="secondary">

                        <span>Cancel</span>

                    </Button>

                    <Button disabled={ submitting }
                            className={ style['testimonial-button'] }
                            type="submit"
                            theme="success">

                        <span>Save</span>

                    </Button>

                </div>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'testimonial',
    fields: ['id', 'author_name', 'organisation_name', 'content', 'course_id']
};

function mapStateToProps(state) {

    const { testimonialFormMode, defaultTestimonialForm, testimonialToEdit, selectedCourseId } = state.courseList;

    return {
        initialValues: formInitialiser.getInitialValues(testimonialFormMode, defaultTestimonialForm, testimonialToEdit),
        mode: testimonialFormMode,
        selectedCourseId
    };
}

function mapDispatchToProps(dispatch) {

    return {
        createSuccess: (courseId) => {

            dispatch(courseListActions.hideTestimonialFormOverlay());
            dispatch(courseListActions.loadSelectedTestimonials(courseId));
        },
        updateSuccess: (courseId) => {

            dispatch(courseListActions.hideTestimonialFormOverlay());
            dispatch(courseListActions.loadSelectedTestimonials(courseId));
        },
        cancelTestimonialFormOverlay: () => {

            dispatch(courseListActions.cancelTestimonialFormOverlay());
        }
    };
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(TestimonialForm, style));


// WEBPACK FOOTER //
// ./components/TestimonialForm/index.js